module.exports = __webpack_public_path__ + "static/media/design.bb779316.jpg";